export default __webpack_public_path__ + "static/media/GROCERYpOS.2a354357.png";